<template>
    <Card :bordered="false" class="border-radius-0">
        <CCard
            :isLoading="isLoading"
            v-model:columns="state.columns"
            v-model:page="state.page"
            :options="state.tableOptions"
            :manages="state.manages"
            :manageExtras="state.manageExtras"
            :rowActions="state.rowActions"
            :colProp="{ xs: { span: 24 }, xl: { span: 12 } }"
            @search="search => onSearch({ props, ...search })"
        >
            <template v-slot:item="{ record }">
                <div class="p-2">
                    <div class="d-flex">
                        <div v-if="record.refFrom?.refImage?.url" class="my-auto mr-2">
                            <Avatar size="large" :src="parseUrl(record.refFrom.refImage.url)"></Avatar>
                        </div>
                        <div class="text-primary my-auto">
                            <a href="javascript:void(0)" @click="() => onClickNotification(record)">
                                <span>{{ record.title }}</span>
                                <Tag color="green" class="mx-0 ml-2" v-if="!record.isRead">
                                    <small>{{ $t("views.notification.unread") }}</small>
                                </Tag>
                            </a>
                        </div>
                    </div>
                    <div>
                        <small>{{ record.desc }}</small>
                    </div>
                    <div class="text-right">
                        <small>{{ record.refFrom?.fullName }} ({{ moment(record.createDate).format("DD/MM/YYYY HH:mm") }})</small>
                    </div>
                </div>
            </template>
        </CCard>
    </Card>
</template>

<script>
import { Avatar, Card, Tag } from "ant-design-vue";
import moment from "moment";
import { computed, defineAsyncComponent, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { state as stateApp } from "../../../app.logic";
import { onClickNotification } from "../../../components/layout/app-layout/notification.logic";
import { parseUrl } from "../../../utils/util";
import { initState, isLoading, onSearch, state } from "./notification.logic";

export default defineComponent({
    components: {
        Card,
        Avatar,
        Tag,
        CCard: defineAsyncComponent(() => import("../../../components/card/CCard"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext }
    },
    setup(props) {
        const i18n = useI18n();
        initState({ props });
        const title = computed(() => i18n.t("model.notification.modelName"));
        return { props, title, isLoading, state, onSearch, moment, onClickNotification, parseUrl };
    }
});
</script>
